var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", [
    _c(
      "div",
      {
        staticClass: "container feedback template-bg-gray",
        class: { "my-position-relative": _vm.isStatus }
      },
      [
        _vm.isStatus
          ? _c(
              "md-card",
              {
                staticClass:
                  "request-status loop_container bg-transparent update-request-form-common"
              },
              [
                _c(
                  "md-card-content",
                  {
                    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "card form-wrapper text-center p-20" },
                      [
                        _c("h4", {
                          staticClass: "template-custom-title",
                          domProps: { innerHTML: _vm._s(_vm.statusMsg) }
                        })
                      ]
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        [
          _c("snackbar", {
            ref: "snackbar",
            attrs: {
              baseSize: "100px",
              position: "top-center",
              wrapClass: "",
              colors: { open: "#3DBD7D" },
              holdTime: 5000,
              multiple: false
            }
          })
        ],
        _vm._v(" "),
        !_vm.isStatus
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "loop_container bg-transparent update-request-form-common",
                      class: { "emailreq-ty": _vm.success }
                    },
                    [
                      _c("div", { staticClass: "card form-wrapper" }, [
                        _c(
                          "div",
                          {
                            staticClass: "feedback_container feedback_newupdate"
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-12 text-center" },
                                [
                                  _c("img", {
                                    staticClass: "top-logo custom-logo",
                                    attrs: {
                                      src: _vm.logoURL,
                                      alt:
                                        _vm.community.content &&
                                        _vm.community.content.parameter2
                                          ? _vm.community.content.parameter2
                                          : "Community Logo"
                                    }
                                  })
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 common-space-from-logo"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.success,
                                          expression: "!success"
                                        }
                                      ],
                                      staticClass: "text-center"
                                    },
                                    [
                                      _vm.memberid !== "undefined" &&
                                      typeof _vm.memberid !== "undefined" &&
                                      _vm.memberid !== "null" &&
                                      _vm.memberid !== ""
                                        ? _c("div", [
                                            _c(
                                              "h2",
                                              { staticClass: "template-title" },
                                              [
                                                _vm._v(
                                                  "Know someone else who could help?"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "custom-content my-text-center"
                                              },
                                              [
                                                _vm._v(
                                                  "Please let us know below and we will forward the request on your behalf.\n                                                Note that we will not use your contact's information for any other purposes."
                                                )
                                              ]
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  (_vm.success && _vm.action == "yes") ||
                                  (_vm.successReferral == true &&
                                    _vm.action == "no") ||
                                  (_vm.success &&
                                    _vm.successReferral === false &&
                                    _vm.action == "no" &&
                                    (_vm.memberid === "undefined" ||
                                      typeof _vm.memberid === "undefined" ||
                                      _vm.memberid === "null" ||
                                      _vm.memberid === ""))
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "header-text text-center unsubscribepage-thankumsg",
                                          class: {
                                            "email-actionpage-tmsg": !_vm.success
                                          }
                                        },
                                        [
                                          _c(
                                            "h1",
                                            {
                                              staticClass: "template-title mt-0"
                                            },
                                            [_vm._v("Thank you!")]
                                          ),
                                          _vm._v(" "),
                                          this.memberid !== "undefined" &&
                                          typeof this.memberid !==
                                            "undefined" &&
                                          this.memberid !== "null" &&
                                          this.memberid !== "" &&
                                          !_vm.emailUpdate
                                            ? _c("div", [
                                                _vm.isProfileValidation &&
                                                !_vm.isEmailSection &&
                                                _vm.isUpdateProfileFlag
                                                  ? _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name:
                                                              "click-outside",
                                                            rawName:
                                                              "v-click-outside",
                                                            value: _vm.outside,
                                                            expression:
                                                              "outside"
                                                          }
                                                        ]
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "custom-content"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "We matched you to this request based on the below  information. Is this still correct?"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.adviser
                                                          .profileValidationFlag ==
                                                        _vm.configureFields
                                                          .profileUpdateInterest
                                                          ? _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "custom-content"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Please choose (or remove) interests that we may use to match you to relevant requests."
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            class:
                                                              _vm.adviser
                                                                .profileValidationFlag ==
                                                              _vm
                                                                .configureFields
                                                                .profileUpdateInterest
                                                                ? "interest-div"
                                                                : "emailreq-profileupdate"
                                                          },
                                                          [
                                                            _vm.adviser
                                                              .profileValidationFlag ==
                                                            _vm.configureFields
                                                              .profileUpdateOccupation
                                                              ? _c("div", [
                                                                  _vm.isEditing &&
                                                                  _vm.community
                                                                    .communityPortal ==
                                                                    "protopia"
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-lg-2 col-sm-3 update-profile-response-label"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "Role:"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-lg-10 col-sm-9"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "md-field",
                                                                                    {
                                                                                      staticClass:
                                                                                        "profileValidation"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "md-input",
                                                                                        {
                                                                                          directives: [
                                                                                            {
                                                                                              name:
                                                                                                "focus",
                                                                                              rawName:
                                                                                                "v-focus"
                                                                                            }
                                                                                          ],
                                                                                          staticClass:
                                                                                            "d-block-w-100 update-profile-template-input",
                                                                                          attrs: {
                                                                                            name:
                                                                                              "memberRoles",
                                                                                            "aria-label":
                                                                                              "Role"
                                                                                          },
                                                                                          on: {
                                                                                            input:
                                                                                              _vm.saveChanges
                                                                                          },
                                                                                          model: {
                                                                                            value:
                                                                                              _vm
                                                                                                .memberObj
                                                                                                .memberRoles,
                                                                                            callback: function(
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm.memberObj,
                                                                                                "memberRoles",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                            expression:
                                                                                              "memberObj.memberRoles"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "sr-only",
                                                                                          attrs: {
                                                                                            id:
                                                                                              "role-description"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                                                             Please enter your role.\n                                                                         "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-lg-2 col-sm-3 update-profile-response-label"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "Organization:"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-lg-10 col-sm-9"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "md-field",
                                                                                    {
                                                                                      staticClass:
                                                                                        "profileValidation"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "md-input",
                                                                                        {
                                                                                          staticClass:
                                                                                            "d-block-w-100 update-profile-template-input",
                                                                                          attrs: {
                                                                                            "aria-describedby":
                                                                                              "org-description",
                                                                                            name:
                                                                                              "organization",
                                                                                            "aria-label":
                                                                                              "Organization"
                                                                                          },
                                                                                          on: {
                                                                                            input:
                                                                                              _vm.saveChanges
                                                                                          },
                                                                                          model: {
                                                                                            value:
                                                                                              _vm
                                                                                                .memberObj
                                                                                                .organization,
                                                                                            callback: function(
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm.memberObj,
                                                                                                "organization",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                            expression:
                                                                                              "memberObj.organization"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "sr-only",
                                                                                          attrs: {
                                                                                            id:
                                                                                              "org-description"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                                                             Please enter your organization name.\n                                                                         "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.adviser
                                                              .profileValidationFlag ==
                                                            _vm.configureFields
                                                              .profileUpdateInterest
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "mb-0"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "row text-center my"
                                                                      },
                                                                      [
                                                                        _vm._l(
                                                                          _vm.randomInterest,
                                                                          function(
                                                                            randomInterestItem
                                                                          ) {
                                                                            return [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  key: randomInterestItem,
                                                                                  staticClass:
                                                                                    "col-md-4 col-sm-4 col-xs-6 width100"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "md-checkbox",
                                                                                    {
                                                                                      key: randomInterestItem,
                                                                                      staticClass:
                                                                                        "my-round-checkbox",
                                                                                      attrs: {
                                                                                        value: randomInterestItem,
                                                                                        name: randomInterestItem
                                                                                      },
                                                                                      model: {
                                                                                        value:
                                                                                          _vm.selectedInterestList,
                                                                                        callback: function(
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.selectedInterestList = $$v
                                                                                        },
                                                                                        expression:
                                                                                          "selectedInterestList"
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          randomInterestItem
                                                                                        )
                                                                                      ),
                                                                                      _c(
                                                                                        "md-tooltip",
                                                                                        {
                                                                                          attrs: {
                                                                                            "md-direction":
                                                                                              "right"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              randomInterestItem
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          }
                                                                        )
                                                                      ],
                                                                      2
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.adviser
                                                              .profileValidationFlag ==
                                                            _vm.configureFields
                                                              .profileUpdateGeography
                                                              ? _c("div", [
                                                                  _vm.isEditing &&
                                                                  _vm.community
                                                                    .communityPortal ==
                                                                    "protopia"
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row"
                                                                            },
                                                                            [
                                                                              _vm._m(
                                                                                0
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-lg-10 col-xs-9"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "md-field",
                                                                                    {
                                                                                      staticClass:
                                                                                        "profileValidation"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "md-input",
                                                                                        {
                                                                                          directives: [
                                                                                            {
                                                                                              name:
                                                                                                "focus",
                                                                                              rawName:
                                                                                                "v-focus"
                                                                                            }
                                                                                          ],
                                                                                          staticClass:
                                                                                            "d-block-w-100 update-profile-template-input",
                                                                                          attrs: {
                                                                                            id:
                                                                                              "city-input-share",
                                                                                            "aria-describedby":
                                                                                              "city-description",
                                                                                            name:
                                                                                              "city",
                                                                                            "aria-label":
                                                                                              "City"
                                                                                          },
                                                                                          on: {
                                                                                            input:
                                                                                              _vm.saveChanges
                                                                                          },
                                                                                          model: {
                                                                                            value:
                                                                                              _vm
                                                                                                .memberObj
                                                                                                .city,
                                                                                            callback: function(
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm.memberObj,
                                                                                                "city",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                            expression:
                                                                                              "memberObj.city"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "sr-only",
                                                                                          attrs: {
                                                                                            id:
                                                                                              "city-description"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                                                                Please enter your city.\n                                                                            "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row"
                                                                            },
                                                                            [
                                                                              _vm._m(
                                                                                1
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-lg-10 col-xs-9"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "md-field",
                                                                                    {
                                                                                      staticClass:
                                                                                        "profileValidation"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "md-input",
                                                                                        {
                                                                                          staticClass:
                                                                                            "d-block-w-100 update-profile-template-input",
                                                                                          attrs: {
                                                                                            id:
                                                                                              "state-input-share",
                                                                                            "aria-describedby":
                                                                                              "state-description",
                                                                                            name:
                                                                                              "state",
                                                                                            "aria-label":
                                                                                              "State"
                                                                                          },
                                                                                          on: {
                                                                                            input:
                                                                                              _vm.saveChanges
                                                                                          },
                                                                                          model: {
                                                                                            value:
                                                                                              _vm
                                                                                                .memberObj
                                                                                                .state,
                                                                                            callback: function(
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm.memberObj,
                                                                                                "state",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                            expression:
                                                                                              "memberObj.state"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "sr-only",
                                                                                          attrs: {
                                                                                            id:
                                                                                              "state-description"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                                                                 Please enter your state.\n                                                                             "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row"
                                                                            },
                                                                            [
                                                                              _vm._m(
                                                                                2
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-lg-10 col-xs-9"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "md-field",
                                                                                    {
                                                                                      staticClass:
                                                                                        "profileValidation"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "md-input",
                                                                                        {
                                                                                          staticClass:
                                                                                            "d-block-w-100 update-profile-template-input",
                                                                                          attrs: {
                                                                                            id:
                                                                                              "country-input-share",
                                                                                            "aria-describedby":
                                                                                              "country-description",
                                                                                            name:
                                                                                              "country",
                                                                                            "aria-label":
                                                                                              "Country"
                                                                                          },
                                                                                          on: {
                                                                                            input:
                                                                                              _vm.saveChanges
                                                                                          },
                                                                                          model: {
                                                                                            value:
                                                                                              _vm
                                                                                                .memberObj
                                                                                                .country,
                                                                                            callback: function(
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm.memberObj,
                                                                                                "country",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                            expression:
                                                                                              "memberObj.country"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "sr-only",
                                                                                          attrs: {
                                                                                            id:
                                                                                              "country-description"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                                                                 Please enter your country.\n                                                                             "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.adviser
                                                              .profileValidationFlag ==
                                                            _vm.configureFields
                                                              .profileUpdatePhoneNumber
                                                              ? _c("div", [
                                                                  _vm.isEditing &&
                                                                  _vm.community
                                                                    .communityPortal ==
                                                                    "protopia"
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row",
                                                                              staticStyle: {
                                                                                display:
                                                                                  "flex"
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-lg-1 col-sm-1 update-profile-response-label width100",
                                                                                  staticStyle: {
                                                                                    width:
                                                                                      "auto",
                                                                                    "white-space":
                                                                                      "nowrap"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "Phone Number:"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-lg-11 col-sm-11"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "md-field",
                                                                                    {
                                                                                      staticClass:
                                                                                        "profileValidation"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "md-input",
                                                                                        {
                                                                                          directives: [
                                                                                            {
                                                                                              name:
                                                                                                "focus",
                                                                                              rawName:
                                                                                                "v-focus"
                                                                                            }
                                                                                          ],
                                                                                          staticClass:
                                                                                            "d-block-w-100 update-profile-template-input",
                                                                                          attrs: {
                                                                                            "aria-describedby":
                                                                                              "phonenumber-description",
                                                                                            name:
                                                                                              "phoneNumbers",
                                                                                            "aria-label":
                                                                                              "Phone Number"
                                                                                          },
                                                                                          on: {
                                                                                            input:
                                                                                              _vm.saveChanges
                                                                                          },
                                                                                          model: {
                                                                                            value:
                                                                                              _vm
                                                                                                .memberObj
                                                                                                .phoneNumbers[0],
                                                                                            callback: function(
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm
                                                                                                  .memberObj
                                                                                                  .phoneNumbers,
                                                                                                0,
                                                                                                typeof $$v ===
                                                                                                  "string"
                                                                                                  ? $$v.trim()
                                                                                                  : $$v
                                                                                              )
                                                                                            },
                                                                                            expression:
                                                                                              "memberObj.phoneNumbers[0]"
                                                                                          }
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "sr-only",
                                                                                          attrs: {
                                                                                            id:
                                                                                              "phonenumber-description"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                                                                 Please enter your phone number.\n                                                                             "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.adviser
                                                              .profileValidationFlag ==
                                                            _vm.configureFields
                                                              .profileUpdateLinkedInUrl
                                                              ? _c("div", [
                                                                  _vm.isEditing &&
                                                                  _vm.community
                                                                    .communityPortal ==
                                                                    "protopia"
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row",
                                                                              staticStyle: {
                                                                                display:
                                                                                  "flex"
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-lg-2 col-sm-2 update-profile-response-label width100",
                                                                                  staticStyle: {
                                                                                    width:
                                                                                      "auto",
                                                                                    "white-space":
                                                                                      "nowrap"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "LinkedIn Url:"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-lg-10 col-sm-10"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "md-field",
                                                                                    {
                                                                                      staticClass:
                                                                                        "profileValidation"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "md-input",
                                                                                        {
                                                                                          directives: [
                                                                                            {
                                                                                              name:
                                                                                                "focus",
                                                                                              rawName:
                                                                                                "v-focus"
                                                                                            }
                                                                                          ],
                                                                                          staticClass:
                                                                                            "d-block-w-100 update-profile-template-input",
                                                                                          attrs: {
                                                                                            name:
                                                                                              "linkedIn"
                                                                                          },
                                                                                          on: {
                                                                                            input:
                                                                                              _vm.saveChanges
                                                                                          },
                                                                                          model: {
                                                                                            value:
                                                                                              _vm
                                                                                                .memberObj
                                                                                                .linkedIn,
                                                                                            callback: function(
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm.memberObj,
                                                                                                "linkedIn",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                            expression:
                                                                                              "memberObj.linkedIn"
                                                                                          }
                                                                                        }
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "btn-block"
                                                          },
                                                          [
                                                            _vm.community
                                                              .communityPortal ==
                                                            "linkedin"
                                                              ? _c(
                                                                  "button",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "focus",
                                                                        rawName:
                                                                          "v-focus"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "btn linkedin-btn",
                                                                    attrs: {
                                                                      type:
                                                                        "button"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.clickUpdateProfile(
                                                                          true
                                                                        ),
                                                                          _vm.saveProfile(
                                                                            "blank"
                                                                          ),
                                                                          _vm.updateLinkedinProfile
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Update from LinkedIn"
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "btn-block"
                                                          },
                                                          [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "btn template-button btn-lightbg",
                                                                style:
                                                                  _vm.nextCloseBtn,
                                                                attrs: {
                                                                  type: "button"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.goToNext()
                                                                  }
                                                                }
                                                              },
                                                              [_vm._v("Next")]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass: "h-54"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.isEmailSection
                                                  ? _c("div", [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "my-text-center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Would you like to adjust how often we ask you for help with requests matching your profile?"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-md-12 text-center"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "progressbar-block my"
                                                                },
                                                                [
                                                                  _c(
                                                                    "ul",
                                                                    {
                                                                      staticClass:
                                                                        "progressbar"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "li",
                                                                        {
                                                                          class: {
                                                                            success:
                                                                              _vm
                                                                                .adviser
                                                                                .frequency ==
                                                                              "as often as needed"
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.changeEmailFrequency(
                                                                                "as often as needed"
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "All"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm.frequency ==
                                                                          "as often as needed"
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "success-text"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "(active)"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "li",
                                                                        {
                                                                          class: {
                                                                            success:
                                                                              _vm
                                                                                .adviser
                                                                                .frequency ==
                                                                              "daily"
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.changeEmailFrequency(
                                                                                "daily"
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "Daily"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm.frequency ==
                                                                          "daily"
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "success-text"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "(active)"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "li",
                                                                        {
                                                                          class: {
                                                                            success:
                                                                              _vm
                                                                                .adviser
                                                                                .frequency ==
                                                                              "once a week"
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.changeEmailFrequency(
                                                                                "once a week"
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "Weekly"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm.frequency ==
                                                                          "once a week"
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "success-text"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "(active)"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "li",
                                                                        {
                                                                          class: {
                                                                            success:
                                                                              _vm
                                                                                .adviser
                                                                                .frequency ==
                                                                              "once a month"
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.changeEmailFrequency(
                                                                                "once a month"
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "Monthly"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm.frequency ==
                                                                          "once a month"
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "success-text"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "(active)"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "li",
                                                                        {
                                                                          class: {
                                                                            success:
                                                                              _vm
                                                                                .adviser
                                                                                .frequency ==
                                                                              "once a quarter"
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.changeEmailFrequency(
                                                                                "once a quarter"
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                "Quarterly"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm.frequency ==
                                                                          "once a quarter"
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "success-text"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "(active)"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "btn-block"
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "btn template-button btn-darkbg mb_0",
                                                              style:
                                                                _vm.emailBtn,
                                                              attrs: {
                                                                href:
                                                                  "javascript:void(0)"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.updateEmailFrequency()
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("Submit")]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "btn-block"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn template-button btn-lightbg",
                                                              style:
                                                                _vm.nextCloseBtn,
                                                              attrs: {
                                                                type: "button"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.closeBtn()
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("Close")]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "h-54"
                                                      })
                                                    ])
                                                  : _vm._e()
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.successReferral === false &&
                                      _vm.success === false &&
                                      _vm.action === "no",
                                    expression:
                                      "(successReferral === false && success === false && action === 'no')"
                                  }
                                ],
                                staticClass: "nofeedback"
                              },
                              [
                                _c(
                                  "form",
                                  {
                                    staticClass: "template-form",
                                    attrs: { "data-vv-scope": "referral" },
                                    on: {
                                      submit: function($event) {
                                        $event.preventDefault()
                                        return _vm.submitReferral("referral")
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _vm._m(3),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-4 nofeedback-customspace mb-17"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "input-group" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "template-label"
                                                },
                                                [_vm._v("First Name")]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.trim",
                                                    value:
                                                      _vm.referral.recipient
                                                        .firstName,
                                                    expression:
                                                      "referral.recipient.firstName",
                                                    modifiers: { trim: true }
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  },
                                                  {
                                                    name: "focus",
                                                    rawName: "v-focus"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control input-value",
                                                attrs: {
                                                  type: "text",
                                                  autocomplete: "given-name",
                                                  id: "referralName",
                                                  name: "recipient_firstname"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.referral.recipient
                                                      .firstName
                                                },
                                                on: {
                                                  input: [
                                                    function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.referral.recipient,
                                                        "firstName",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    function(e) {
                                                      return (_vm.referral.recipient.firstName = _vm.sanitizeInput(
                                                        e.target.value
                                                      ))
                                                    }
                                                  ],
                                                  blur: function($event) {
                                                    return _vm.$forceUpdate()
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.errors.has(
                                                        "referral.recipient_firstname"
                                                      ),
                                                      expression:
                                                        "errors.has('referral.recipient_firstname')"
                                                    }
                                                  ],
                                                  staticClass: "error"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "referral.recipient_firstname"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-4 nofeedback-customspace mb-17"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "input-group" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "template-label"
                                                },
                                                [
                                                  _vm._v(
                                                    "Last Name (required):"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "sr-only",
                                                  attrs: { id: "lname-help" }
                                                },
                                                [
                                                  _vm._v(
                                                    "Please enter your last name."
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.trim",
                                                    value:
                                                      _vm.referral.recipient
                                                        .lastName,
                                                    expression:
                                                      "referral.recipient.lastName",
                                                    modifiers: { trim: true }
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  },
                                                  {
                                                    name: "focus",
                                                    rawName: "v-focus"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control input-value",
                                                attrs: {
                                                  "aria-describedby":
                                                    "lname-help",
                                                  type: "text",
                                                  autocomplete: "family-name",
                                                  id: "referralName",
                                                  name: "recipient_lastname"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.referral.recipient
                                                      .lastName
                                                },
                                                on: {
                                                  input: [
                                                    function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.referral.recipient,
                                                        "lastName",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    function(e) {
                                                      return (_vm.referral.recipient.lastName = _vm.sanitizeInput(
                                                        e.target.value
                                                      ))
                                                    }
                                                  ],
                                                  blur: function($event) {
                                                    return _vm.$forceUpdate()
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.errors.has(
                                                        "referral.recipient_lastname"
                                                      ),
                                                      expression:
                                                        "errors.has('referral.recipient_lastname')"
                                                    }
                                                  ],
                                                  staticClass: "error"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "referral.recipient_lastname"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _vm._m(4),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-4 nofeedback-customspace mb-17"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "input-group" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "template-label"
                                                },
                                                [_vm._v("Email (required):")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "sr-only",
                                                  attrs: { id: "email-help" }
                                                },
                                                [
                                                  _vm._v(
                                                    "Please enter your email."
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.trim",
                                                    value:
                                                      _vm.referral.recipient
                                                        .email,
                                                    expression:
                                                      "referral.recipient.email",
                                                    modifiers: { trim: true }
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required|email",
                                                    expression:
                                                      "'required|email'"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control input-value",
                                                attrs: {
                                                  "aria-describedby":
                                                    "email-help",
                                                  type: "email",
                                                  autocomplete: "email",
                                                  name: "recipient_email"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.referral.recipient.email
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.checkMemberStatus(
                                                      _vm.referral.recipient
                                                        .email
                                                    )
                                                  },
                                                  input: [
                                                    function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.referral.recipient,
                                                        "email",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    function(e) {
                                                      return (_vm.referral.recipient.email = _vm.sanitizeInput(
                                                        e.target.value
                                                      ))
                                                    }
                                                  ],
                                                  blur: function($event) {
                                                    return _vm.$forceUpdate()
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.errors.has(
                                                        "referral.recipient_email"
                                                      ),
                                                      expression:
                                                        "errors.has('referral.recipient_email')"
                                                    }
                                                  ],
                                                  staticClass: "error"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "referral.recipient_email"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _vm._m(5),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-4 nofeedback-customspace mb-17"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "input-group" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "template-label",
                                                  attrs: { for: "adviser_name" }
                                                },
                                                [_vm._v("Name:")]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.trim",
                                                    value:
                                                      _vm.referral.adviser.name,
                                                    expression:
                                                      "referral.adviser.name",
                                                    modifiers: { trim: true }
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control input-value",
                                                attrs: {
                                                  id: "adviser_name",
                                                  type: "text",
                                                  name: "adviser_name",
                                                  "aria-label":
                                                    "Please enter your name"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.referral.adviser.name
                                                },
                                                on: {
                                                  input: [
                                                    function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.referral.adviser,
                                                        "name",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    function(e) {
                                                      return (_vm.referral.adviser.name = _vm.sanitizeInput(
                                                        e.target.value
                                                      ))
                                                    }
                                                  ],
                                                  blur: function($event) {
                                                    return _vm.$forceUpdate()
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.errors.has(
                                                        "referral.adviser_name"
                                                      ),
                                                      expression:
                                                        "errors.has('referral.adviser_name')"
                                                    }
                                                  ],
                                                  staticClass: "error"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "referral.adviser_name"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-4 nofeedback-customspace mb-17"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "input-group" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "template-label",
                                                  attrs: {
                                                    for: "adviser_email"
                                                  }
                                                },
                                                [_vm._v("Email:")]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.trim",
                                                    value:
                                                      _vm.referral.adviser
                                                        .email,
                                                    expression:
                                                      "referral.adviser.email",
                                                    modifiers: { trim: true }
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required|email",
                                                    expression:
                                                      "'required|email'"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control input-value",
                                                attrs: {
                                                  id: "adviser_email",
                                                  type: "text",
                                                  name: "adviser_email",
                                                  "aria-label":
                                                    "Please enter your email"
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.referral.adviser.email
                                                },
                                                on: {
                                                  input: [
                                                    function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.referral.adviser,
                                                        "email",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    function(e) {
                                                      return (_vm.referral.adviser.email = _vm.sanitizeInput(
                                                        e.target.value
                                                      ))
                                                    }
                                                  ],
                                                  blur: function($event) {
                                                    return _vm.$forceUpdate()
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.errors.has(
                                                        "referral.adviser_email"
                                                      ),
                                                      expression:
                                                        "errors.has('referral.adviser_email')"
                                                    }
                                                  ],
                                                  staticClass: "error"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "referral.adviser_email"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _vm._m(6),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-sm-8" }, [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "template-label" },
                                              [_vm._v("Message")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "template-input-text-area common-question-textarea-for-v1-v2 unsubscribe-height"
                                              },
                                              [
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.referral.message,
                                                      expression:
                                                        "referral.message"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: "required|max:500",
                                                      expression:
                                                        "'required|max:500'"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    "aria-label":
                                                      "Referral message textarea, character count available.",
                                                    "aria-describedby":
                                                      "character-counter-referral",
                                                    rows: "7",
                                                    maxlength: _vm.maxReferral,
                                                    name: "message",
                                                    placeholder:
                                                      "[Click here to edit]\nI help students and alumni..."
                                                  },
                                                  domProps: {
                                                    value: _vm.referral.message
                                                  },
                                                  on: {
                                                    keyup:
                                                      _vm.countdownReferral,
                                                    input: [
                                                      function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referral,
                                                          "message",
                                                          $event.target.value
                                                        )
                                                      },
                                                      function(e) {
                                                        return (_vm.referral.message = _vm.sanitizeInput(
                                                          e.target.value
                                                        ))
                                                      }
                                                    ]
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.errors.has(
                                                          "referral.message"
                                                        ),
                                                        expression:
                                                          "errors.has('referral.message')"
                                                      }
                                                    ],
                                                    staticClass: "error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "referral.message"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group pd-remove unsubscribe-btn mb-0-custom"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "char-counter template-subject-counter",
                                                        class: {
                                                          "char-count-error":
                                                            _vm.exceedsMaxCountReferral
                                                        },
                                                        attrs: {
                                                          id:
                                                            "character-counter-referral",
                                                          "aria-live": "polite"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.remainingCountReferral
                                                          ) + "  / 500 "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "sr-only"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "characters used out of 500."
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 col-sm-12 text-right"
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "sr-only",
                                                  attrs: { id: "submit-info" }
                                                },
                                                [
                                                  _vm._v(
                                                    "This will send the request to the referral you specified."
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn template-button submitBtn",
                                                  style: _vm.styleObjectBtn,
                                                  attrs: {
                                                    "aria-describedby":
                                                      "submit-info",
                                                    type: "submit"
                                                  }
                                                },
                                                [_vm._v("Share Request")]
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            (_vm.success === false &&
                              _vm.successReferral == false) ||
                            (_vm.success &&
                              _vm.successReferral == false &&
                              _vm.action == "no" &&
                              _vm.memberid != "undefined" &&
                                typeof _vm.memberid != "undefined" &&
                                _vm.memberid != "null" &&
                                _vm.memberid != "")
                              ? _c("div", [
                                  _vm._m(7),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "email-request-review" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "template-request-review"
                                        },
                                        [
                                          _vm.createdByMember.first &&
                                          _vm.createdByMember.last
                                            ? _c("h2", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.createdByMember.first +
                                                      " " +
                                                      _vm.createdByMember.last
                                                  )
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.memberSchool
                                            ? _c("h5", [
                                                _vm._v(_vm._s(_vm.memberSchool))
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("h6", [
                                            _vm._v(_vm._s(_vm.ask.subject))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "font-color" },
                                            [_vm._v(_vm._s(_vm.ask.text))]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "list-inline text-center footer-links" },
                        [
                          _c("li", [
                            _vm.community.content &&
                            _vm.community.content.landingPageURL &&
                            _vm.community.content.landingPageURL.length
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "links",
                                    attrs: {
                                      href:
                                        _vm.community.content.landingPageURL,
                                      target: "_blank",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Learn More")]
                                )
                              : _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "javascript:void(0)",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Learn More")]
                                )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm.community.content &&
                            _vm.community.content.termsConditionsURL &&
                            _vm.community.content.termsConditionsURL.length
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "links",
                                    attrs: {
                                      href:
                                        _vm.community.content
                                          .termsConditionsURL,
                                      target: "_blank",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Terms Of Use [pdf]")]
                                )
                              : _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "javascript:void(0)",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Terms Of Use [pdf]")]
                                )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm.community.content &&
                            _vm.community.content.unsubscribePageURL &&
                            _vm.community.content.unsubscribePageURL.length
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      tabindex: "0",
                                      href:
                                        _vm.community.content
                                          .unsubscribePageURL,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("Opt Out")]
                                )
                              : _c(
                                  "a",
                                  { attrs: { href: "javascript:void(0)" } },
                                  [_vm._v("Opt Out")]
                                )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "unsubscribe-community-logo email-actionpage-flogo"
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://www.protopia.co",
                                target: "_blank"
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm.footerLogoURL,
                                  alt: "Community Logo"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-lg-2 col-xs-3 update-profile-response-label width100"
      },
      [_c("label", { attrs: { for: "city-input-share" } }, [_vm._v("City:")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-lg-2 col-xs-3 update-profile-response-label width100"
      },
      [_c("label", { attrs: { for: "state-input-share" } }, [_vm._v("State:")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-lg-2 col-xs-3 update-profile-response-label width100"
      },
      [
        _c("label", { attrs: { for: "country-input-share" } }, [
          _vm._v("Country:")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-4 nofeedback-customspace" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("div", [_vm._v("Recipient")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-4 nofeedback-customspace" }, [
      _c("div", { staticClass: "form-group" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-4 nofeedback-customspace" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("div", [_vm._v("Your Details")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-4 nofeedback-customspace" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("div", [_vm._v("Personal Message")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row my" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("h1", { staticClass: "text-center email-request-title" }, [
          _vm._v("FYI, here's the request")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ac6ea440", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac6ea440","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShareRequest.vue
// module id = null
// module chunks = 